const root = `td-register/limitStop/`
const urls = {
  getDetail: root + 'detail',
  getList: root + 'page',
  remove: root + 'remove',
  add: root + 'save',
  detail: root + 'detail',
  update: root + 'update',
  existDecisionNo: root + 'existDecisionNo',
  existDelayDecisionNo: root + 'existDelayDecisionNo'
}

// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}

export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}
export const detailByPenalizeId = penalizeId => {
  return $http.get(urls.detail, { penalizeId: penalizeId })
}
export const update = obj => {
  return $http.post(urls.update, obj)
}
export const existDelayDecisionNo = obj => {
  return $http.get(urls.existDelayDecisionNo, obj)
}
export const existDecisionNo = obj => {
  return $http.get(urls.existDecisionNo, obj)
}
export default {
  add,
  update,
  detail,
  getList,
  remove,
  detailByPenalizeId,
  existDelayDecisionNo
}
